import { gql } from '@apollo/client';
import { FAVORITE_ITEM_FIELDS } from './fragments';

// ============================================================================
// Queries
// ============================================================================

export const FAVORITES_QUERY = gql`
  query Favorites($allCustomers: Boolean, $customerNumbers: [String!]) {
    favorites(allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      ...FavoriteItemFields
    }
  }
  ${FAVORITE_ITEM_FIELDS}
`;

export const FAVORITE_LABELS_QUERY = gql`
  query FavoriteLabels($allCustomers: Boolean, $customerNumbers: [String!]) {
    favoriteLabels(allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      name
      color
      sortOrder
    }
  }
`;

export const PINNED_FAVORITES_QUERY = gql`
  query PinnedFavorites($limit: Int = 6, $allCustomers: Boolean, $customerNumbers: [String!]) {
    pinnedFavorites(limit: $limit, allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      ...FavoriteItemFields
    }
  }
  ${FAVORITE_ITEM_FIELDS}
`;

// ============================================================================
// Mutations
// ============================================================================

export const ADD_FAVORITE_MUTATION = gql`
  mutation AddFavorite($articleNumber: String!, $customerNumber: String) {
    addFavorite(articleNumber: $articleNumber, customerNumber: $customerNumber) {
      ...FavoriteItemFields
    }
  }
  ${FAVORITE_ITEM_FIELDS}
`;

export const REMOVE_FAVORITE_MUTATION = gql`
  mutation RemoveFavorite($articleNumber: String!, $customerNumber: String) {
    removeFavorite(articleNumber: $articleNumber, customerNumber: $customerNumber)
  }
`;

export const ADD_FAVORITES_MUTATION = gql`
  mutation AddFavorites($articleNumbers: [String!]!, $customerNumber: String) {
    addFavorites(articleNumbers: $articleNumbers, customerNumber: $customerNumber) {
      ...FavoriteItemFields
    }
  }
  ${FAVORITE_ITEM_FIELDS}
`;

export const UPDATE_FAVORITE_MUTATION = gql`
  mutation UpdateFavorite(
    $articleNumber: String!
    $pinned: Boolean
    $labels: [String!]
    $customerNumber: String
  ) {
    updateFavorite(
      articleNumber: $articleNumber
      pinned: $pinned
      labels: $labels
      customerNumber: $customerNumber
    ) {
      ...FavoriteItemFields
    }
  }
  ${FAVORITE_ITEM_FIELDS}
`;

export const ASSIGN_LABEL_MUTATION = gql`
  mutation AssignLabel($articleNumbers: [String!]!, $label: String!, $customerNumber: String) {
    assignLabel(articleNumbers: $articleNumbers, label: $label, customerNumber: $customerNumber) {
      ...FavoriteItemFields
    }
  }
  ${FAVORITE_ITEM_FIELDS}
`;

export const REMOVE_LABEL_MUTATION = gql`
  mutation RemoveLabel($articleNumbers: [String!]!, $label: String!, $customerNumber: String) {
    removeLabel(articleNumbers: $articleNumbers, label: $label, customerNumber: $customerNumber) {
      ...FavoriteItemFields
    }
  }
  ${FAVORITE_ITEM_FIELDS}
`;

export const CREATE_FAVORITE_LABEL_MUTATION = gql`
  mutation CreateFavoriteLabel($name: String!, $color: String, $customerNumber: String) {
    createFavoriteLabel(name: $name, color: $color, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const RENAME_FAVORITE_LABEL_MUTATION = gql`
  mutation RenameFavoriteLabel($oldName: String!, $newName: String!, $customerNumber: String) {
    renameFavoriteLabel(oldName: $oldName, newName: $newName, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const UPDATE_FAVORITE_LABEL_COLOR_MUTATION = gql`
  mutation UpdateFavoriteLabelColor($name: String!, $color: String, $customerNumber: String) {
    updateFavoriteLabelColor(name: $name, color: $color, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const REORDER_FAVORITE_LABELS_MUTATION = gql`
  mutation ReorderFavoriteLabels($orderedNames: [String!]!, $customerNumber: String) {
    reorderFavoriteLabels(orderedNames: $orderedNames, customerNumber: $customerNumber) {
      name
      color
      sortOrder
    }
  }
`;

export const DELETE_FAVORITE_LABEL_MUTATION = gql`
  mutation DeleteFavoriteLabel($name: String!, $customerNumber: String) {
    deleteFavoriteLabel(name: $name, customerNumber: $customerNumber)
  }
`;
